import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import findIndex from 'lodash.findindex';
import filter from 'lodash.filter';
import { ConsultationForm } from './ConsultationForm';
import { ContactTypeConsultationForm } from './ContactTypeConsultationForm';
import { ConsultationFormType, ConsultationFormContainerType } from '../../../utils/enums';

export class ConsultationFormContainer extends Component {
	render() {
		const { consultationFormContainerType = ConsultationFormContainerType.Voted, loggedUserIsCitizen = false } = this.props;
		return (
			<Fragment>
				{consultationFormContainerType === ConsultationFormContainerType.Contact && (
					<ContactTypeConsultationForm
						items={this.props.items}
						title={this.props.title}
						officeId={this.props.officeId}
						thematicAreaId={this.props.thematicAreaId}
						districtId={this.props.districtId}
						projectId={this.props.projectId}
						isAuth={this.props.isAuth}
						mode={this.props.mode}
						onCancel={this.props.onCancel}
						agreementAccepted={this.props.agreementAccepted}
						agreementHistory={this.props.agreementHistory}
						agreementAcceptedRequired={this.props.agreementAcceptedRequired}
						scrollToAgreement={this.props.scrollToAgreement}
					/>
				)}
				{consultationFormContainerType !== ConsultationFormContainerType.Contact &&
					this.props.items.map((item, index) => {
						const isExecuting = findIndex(this.props.voteExecuting, (id) => id === item.id) !== -1;
						const newResultSummary = filter(this.props.resultSummary, { consultationFormId: item.id });
						return (
							<div key={`consultation-form-${index}`}>
								{item.type != ConsultationFormType.Comment && (
									<ConsultationForm
										{...item}
										prefixName={`consultationForms.${index}.`}
										index={index}
										rowId={index + 1}
										projectType={this.props.projectType}
										disabled={this.props.disabled}
										loggedUserId={this.props.loggedUserId}
										loggedUserIsCitizen={loggedUserIsCitizen}
										agreementAccepted={this.props.agreementAccepted}
										agreementHistory={this.props.agreementHistory}
										agreementAcceptedRequired={this.props.agreementAcceptedRequired}
										onSubmit={this.props.saveAnswers}
										isExecuting={isExecuting}
										isLegalAgeUser={this.props.isLegalAgeUser}
										onlyForLegalAge={this.props.onlyForLegalAge}
										onCancel={this.props.onCancel}
										scrollToAgreement={this.props.scrollToAgreement}
										isOnlyOneConsultationForms={this.props.isOnlyOneConsultationForms}
										isAuth={this.props.isAuth}
										projectStatus={this.props.projectStatus}
										mode={this.props.mode}
										modeName={this.props.modeName}
										loggedOfficeId={this.props.loggedOfficeId}
										officeId={this.props.officeId}
										officeName={this.props.officeName}
										isOnlyOneOffice={this.props.isOnlyOneOffice}
										resultSummary={newResultSummary}
										availableVoteForms={this.props.availableVoteForms}
										voteForms={this.props.voteForms}
										onSetExpandStateItem={this.props.onSetExpandStateItem}
										expand={this.props.expand}
										isPreview={this.props.isPreview}
									/>
								)}
							</div>
						);
					})}
			</Fragment>
		);
	}
}

ConsultationFormContainer.propTypes = {
	disabled: PropTypes.bool,
	loggedUserId: PropTypes.number,
	projectType: PropTypes.number,

	items: PropTypes.arrayOf(
		PropTypes.shape({
			categoryPointDivision: PropTypes.bool,
			id: PropTypes.number,
			isResultPublished: PropTypes.bool,
			maxPoint: PropTypes.number,
			publishType: PropTypes.number,
			shortDescription: PropTypes.string,
			type: PropTypes.number,
			voteFrom: PropTypes.string,
			voteTo: PropTypes.string,

			attachments: PropTypes.arrayOf(
				PropTypes.shape({
					filename: PropTypes.string,
					id: PropTypes.number,
					name: PropTypes.string
				})
			),
			availableConsultationPublishTypes: PropTypes.arrayOf(
				PropTypes.shape({
					id: PropTypes.number,
					name: PropTypes.string
				})
			),
			categories: PropTypes.arrayOf(
				PropTypes.shape({
					id: PropTypes.number,
					maxPoint: PropTypes.number,
					title: PropTypes.string,
					questions: PropTypes.arrayOf(
						PropTypes.shape({
							canComment: PropTypes.bool,
							content: PropTypes.string,
							id: PropTypes.number,
							maxPoint: PropTypes.number,
							order: PropTypes.number,
							questionOptionCount: PropTypes.number,
							questionResultQuantitySum: PropTypes.number,
							questionType: PropTypes.number,

							answers: PropTypes.arrayOf(
								PropTypes.shape({
									categoryId: PropTypes.number,
									id: PropTypes.number,
									questionId: PropTypes.number,
									userId: PropTypes.number,
									answerOptions: PropTypes.arrayOf(
										PropTypes.shape({
											comment: PropTypes.string,
											id: PropTypes.number,
											openDate: PropTypes.string,
											openText: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
											questionMatrixValueId: PropTypes.number,
											questionOptionId: PropTypes.number,
											ranking: PropTypes.number
										})
									)
								})
							),
							questionMatrixValues: PropTypes.arrayOf(
								PropTypes.shape({
									content: PropTypes.string,
									id: PropTypes.number,
									order: PropTypes.number
								})
							),
							questionOptions: PropTypes.arrayOf(
								PropTypes.shape({
									content: PropTypes.string,
									id: PropTypes.number,
									order: PropTypes.number
								})
							),
							questionResults: PropTypes.arrayOf(
								PropTypes.shape({
									id: PropTypes.number,
									quantity: PropTypes.number,
									questionOptionName: PropTypes.string
								})
							)
						})
					)
				})
			),
			resultAttachments: PropTypes.arrayOf(
				PropTypes.shape({
					filename: PropTypes.string,
					id: PropTypes.number,
					name: PropTypes.string
				})
			)
		})
	)
};

ConsultationFormContainer.defaultProps = {
	disabled: false,
	loggedUserId: 0,
	projectType: 0,
	agreementAccepted: false,
	agreementAcceptedRequired: false,
	items: [],
	voteExecuting: []
};
